<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof23">
<p class="para">Looking at the data on senior officers (major generals, lieutenant generals, and generals), it is surprising to find that 13 (4.4%) owned less than 20 serfs, 34 (11.5%) owned between 20 and 100 serfs, and 79 (26.8%) owned more than 100 serfs. Only 2.7% of generals possessed estates. The majority of senior officers (54.2%) had neither serfs nor property.<span class="font01"><sup><span href="#/therussian_endnotes#thent82" id="theft82" title="Link target outside of Sample">82</span></sup></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof23.vue?5cee4ff5